import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Получаем root элемент
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Рендерим приложение
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);